<template>
   <div>
       <div class="title">
           以太网智能网关
           <div class="line"></div>
       </div>
       <el-tabs class="tabContainer" activeName="first" style="padding: 28px 84px">
           <el-tab-pane label="产品介绍" name="first">
               <div class="content">
                   <div class="sm-title">简介</div>
                   <p>
                       以太网关是基于工业物联网架构设计的工业级嵌入式软硬件一体设备，具有丰富的通信接口和高性能的运算处理能力，可以实现多种数据采集、通信规约转换、远程调试、智能监管等功能。网关再可靠性、稳定性、EMC防护能力等方面采用了成熟的专业设计，在物联网领域有广泛的应用前景。</p>
                   <div class="sm-title" style="margin-top: 20px">特点</div>
                   <ul>
                       <li v-for="item in list" :key="item.id">
                           <el-card shadow="always">{{item.content}}</el-card>
                       </li>
                   </ul>
               </div>
           </el-tab-pane>
           <el-tab-pane label="产品展示" name="second">
               <div class="img-div">
                   <img src="../../assets/img/ethernet_light.png"/>
                   <img src="../../assets/img/ethernet_dark.png"/>
               </div>
           </el-tab-pane>
           <el-tab-pane label="技术规格" name="third">
               <div style="text-align: center">
                   <img style="width: 80%" src="@/assets/img/ethernet.png" alt="技术规格">
               </div>
           </el-tab-pane>
       </el-tabs>
   </div>

</template>

<script>
  export default {
    data() {
      return {
        list: [
          {id: 1, content: '多路采集转发：网关拥有完备的数据采集多协议转发功能，拥有百兆以太网、4G、RS232、RS485、CAN、Lora六种通讯接口。'},
          {id: 2, content: '智能网络管理：智能网关系统，平台化管理'},
          {id: 3, content: '跨行业应用：适用于各种寒夜实现互联互通'},
          {id: 4, content: '远程协助平台：远程协助功能，能随时随地接入'}
        ]
      }
    }
  }
</script>

<style scoped lang="less">
    .title {
        padding-top: 50px;
        text-align: center;
        font-size: 34px;
        color: #595757;
    }
    .line {
        width: 250px;
        background: #e5d276;
        height: 4px;
        margin: 10px auto;
    }
    .content {
        margin-top: 20px;
        font-size: 14px;
        /*padding: 52px 130px 52px 170px;*/

        li {
            list-style: none;
            margin-bottom: 20px;
        }
    }

    .demo-image__lazy {
        /*height: 720px;*/
        overflow: auto;
    }

    .sm-title {
        font-size: 24px;
        padding-left: 5px;
        margin-bottom: 15px;
        border-left: 4px solid #e5d276;
    }
    .img-div {
        text-align: center;

        > img {
            width: 80%;
        }
    }
</style>
